import { c as _c } from "react/compiler-runtime";
import { IconButton, Stack, Tooltip } from '@mui/material';
import { useState } from 'react';
export function getVisibleColumnsParam(columns: {
  getIsVisible: () => boolean;
  id: string;
}[], allColumnDefs: {
  name: string;
}[]): string | undefined {
  const allColumnIds = new Set(allColumnDefs.map(c => c.name));
  const visibleIds = columns.filter(col => col.getIsVisible() && allColumnIds.has(col.id)).map(col => col.id);
  return visibleIds.length > 0 && visibleIds.length < allColumnIds.size ? visibleIds.join(',') : undefined;
}
export function download(data: BlobPart | undefined, filename: string, options: BlobPropertyBag) {
  if (!data) {
    return;
  }
  const file = new Blob([data], options);
  const a = document.createElement('a');
  const url = URL.createObjectURL(file);
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  setTimeout(function () {
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }, 0);
}
export const DownloadButton = t0 => {
  const $ = _c(13);
  const {
    tooltip,
    onClick
  } = t0;
  const [isDownloading, setIsDownloading] = useState(false);
  const [downloadSuccess, setDownloadSuccess] = useState(false);
  let t1;
  if ($[0] !== onClick) {
    t1 = () => {
      setIsDownloading(true);
      onClick().then(result => {
        if (result === "cancelled") {
          return;
        }
        setDownloadSuccess(true);
        setTimeout(() => setDownloadSuccess(false), 2000);
      }).finally(() => {
        setIsDownloading(false);
      });
    };
    $[0] = onClick;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleClick = t1;
  let t2;
  if ($[2] !== downloadSuccess || $[3] !== isDownloading || $[4] !== tooltip) {
    t2 = downloadSuccess ? <Stack direction="row" sx={{
      alignItems: "center",
      gap: "4px"
    }}><i className="material-symbols-check text-[18px]" /> Downloaded</Stack> : isDownloading ? "Downloading..." : tooltip;
    $[2] = downloadSuccess;
    $[3] = isDownloading;
    $[4] = tooltip;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <i className="material-symbols-download-rounded" />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== handleClick || $[8] !== isDownloading) {
    t4 = <span><IconButton color="primary" onClick={handleClick} disabled={isDownloading}>{t3}</IconButton></span>;
    $[7] = handleClick;
    $[8] = isDownloading;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t2 || $[11] !== t4) {
    t5 = <Tooltip title={t2}>{t4}</Tooltip>;
    $[10] = t2;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};